import React from 'react';
import * as LucideIcons from 'lucide-react-native';
import type { LucideIcon as LucideIconComponent } from 'lucide-react-native';

function kebabToPascalCase(name: string): string {
  return name
    .split('-')
    .map(segment => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join('');
}

export type LucideIconProps = {
  name: string;
  size?: number;
  color?: string;
};

const LucideIcon: React.FC<LucideIconProps> = ({ name, size = 24, color }) => {
  const componentName = kebabToPascalCase(name);
  const Icon = (LucideIcons as Record<string, unknown>)[componentName] as
    | LucideIconComponent
    | undefined;

  if (!Icon) {
    return null;
  }

  return <Icon size={size} color={color} />;
};

export default LucideIcon;
